import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getSellableProductAll = (filterObj) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SELLABLE_PRODUCT, {
    params: {
      sellableProductId: filterObj.sellableProductId,
      Name: filterObj.name,
      SubjectId: filterObj.subjectId,
      contentAreaId: filterObj.contentAreaId,
      stateId: filterObj.stateId,
      gradeId: filterObj.gradeId,
      gradeLevel: filterObj.gradeLevelId,
      SellableProductId: filterObj.sellableProductId,
      isActive: filterObj.isActive,
      isApproved: filterObj.isApproved,
      OrderByColumn: filterObj.orderByColumn,
      SortDir: filterObj.sortDir,
      PageSize: filterObj.pageSize,
      PageNumber: filterObj.pageNumber,
      SellableProductTypeId: filterObj.sellableProductTypeId,
    },
  });
};

export const postSellableProduct = (postSellableProductData) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SELLABLE_PRODUCT,
    postSellableProductData,
    {}
  );
};

export const deleteSellableProduct = (SellableProductId, userId) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_SELLABLE_PRODUCT, {
    params: {
      sellableProductId: SellableProductId,
      userId: userId,
    },
  });
};

export const getSellableProduct = (SellableProductId) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_SKILL_SUBJECT_ONE + SellableProductId
  );
};

export const getSubjectsSellableProduct = (SellableProductId) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_SELLABLE_PRODUCT_SUBJECTS,
    {
      params: {
        sellableProductId: SellableProductId,
      },
    }
  );
};

export const updateSellableProduct = (updateSellableProduct) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_SELLABLE_PRODUCT,
    updateSellableProduct,
    {}
  );
};

export const postSellableProductSubjects = (
  postSellableProductDataSubjects
) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_SELLABLE_PRODUCT_SUBJECTS,
    postSellableProductDataSubjects,
    {}
  );
};

export const deleteSellableProductSubject = (
  SellableProductIdSubjectId,
  sellableProductId
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_SELLABLE_PRODUCT_SUBJECTS,
    {
      params: {
        subjectId: SellableProductIdSubjectId,
        sellableProductId: sellableProductId,
      },
    }
  );
};

export const getSellableProductById = (id) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_SELLABLE_PRODUCT}/${id}`
  );
};

export const getCannedTestsSellableProduct = (sellableProductId) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_SELLABLE_PRODUCT_CANNED_TESTS,
    {
      params: {
        sellableProductId: sellableProductId,
      },
    }
  );
};

export const deleteSellableProductCannedTest = (
  cannedTestId,
  sellableProductId
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_SELLABLE_PRODUCT_CANNED_TESTS,
    {
      params: {
        cannedTestId: cannedTestId,
        sellableProductId: sellableProductId,
      },
    }
  );
};

export const updateSellableProductCannedTest = (
  cannedTestId: number,
  sellableProductId: number,
  isHandScorable: boolean
) => {
  return AxiosHelper.axiosInstance().put(
    `${APIConstant.CMS_SELLABLE_PRODUCT_CANNED_TESTS}?cannedTestId=${cannedTestId}&sellableProductId=${sellableProductId}&isHandScorable=${isHandScorable}`
  );
};

export const getItemBanksSellableProduct = (sellableProductId) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.CMS_SELLABLE_PRODUCT_ITEM_BANKS,
    {
      params: {
        sellableProductId: sellableProductId,
      },
    }
  );
};

export const deleteSellableProductItemBank = (
  itemBankId,
  sellableProductId
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_SELLABLE_PRODUCT_ITEM_BANKS,
    {
      params: {
        itemBankId: itemBankId,
        sellableProductId: sellableProductId,
      },
    }
  );
};
